import React, { useState } from 'react';
import WorldTimerIcon from './../Icons/WorldTimerIcon';
import PlannerIcon from './../Icons/PlannerIcon';
import PomodoroIcon from './../Icons/PomodoroIcon';
import TimeZoneIcon from './../Icons/TimeZoneIcon';
import TimerIcon from './../Icons/TimerIcon';
import StopWatchIcon from './../Icons/StopWatchIcon';
import RightArrowIcon from './../Icons/RightArrowIcon';
 

const SideBar = ({ onMenuItemClick, activeMenu }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={`relative flex-col items-center h-screen flex-shrink-0  pt-4 border-r border-r-zinc-800 bg-zinc-900 hidden lg:block   ${isExpanded ? 'w-[150px]' : 'w-12'}`}>
            <div className=''>
                <button onClick={handleToggle} className="p-1 mx-3 mb-3 rounded-lg opacity-50 bg-zinc-800 text-zinc-200 hover:opacity-100">
                    <RightArrowIcon />
                </button>
                <button
                    onClick={() => onMenuItemClick('timezone')}
                    className={`group relative flex items-center gap-2 px-3 py-2 ${activeMenu === 'timezone' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400 '}  text-yellow-400 ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}
                >
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'timezone' && isExpanded ? '' : 'hidden'}`}
                    />
                    <span
                        className={`absolute scale-0 px-2 left-11 z-10   text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden' }`} >
                        Timezone
                    </span>

                    <TimeZoneIcon />
                    {isExpanded && <span>Timezones</span>}
                </button>
                <button
                    onClick={() => onMenuItemClick('pomodoro')}
                    className={`group relative flex items-center gap-2 px-3 py-2  ${activeMenu === 'pomodoro' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400 '}   ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}>
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'pomodoro' && isExpanded ? '' : 'hidden'}`}
                    />

                    <span
                        className={`absolute scale-0 px-2 left-11 z-10 text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden' }`} >
                        Pomodoro
                    </span>

                    <PomodoroIcon />
                    {isExpanded && <span>Pomodoro</span>}
                </button>
                <button
                    onClick={() => onMenuItemClick('dailyplanner')}
                    className={`group relative flex items-center gap-2 px-3 py-2 ${activeMenu === 'dailyplanner' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400 '}   ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}>
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'dailyplanner' && isExpanded ? '' : 'hidden'}`}
                    />
                    <span
                        className={`absolute scale-0 px-2 left-11 z-10   text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden' }`}
                    >Daily&nbsp;Planner</span>
                    <PlannerIcon />
                    {isExpanded && <span>Daily Planner</span>}
                </button>
                <button
                    onClick={() => onMenuItemClick('worldtimer')}
                    className={`group relative flex items-center gap-2 px-3 py-2 ${activeMenu === 'worldtimer' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400'}   ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}>
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'worldtimer' && isExpanded ? '' : 'hidden'}`}
                    />
                    <span
                        className={`absolute scale-0 px-2 left-11 z-10 text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden'  }`}
                    >World&nbsp;Timer</span>
                    <WorldTimerIcon />
                    {isExpanded && <span>World Timer</span>}
                </button>
                <button
                    onClick={() => onMenuItemClick('timer')}
                    className={`group relative flex items-center gap-2 px-3 py-2 ${activeMenu === 'timer' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400 '}   ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}>
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'timer' && isExpanded ? '' : 'hidden'}`}
                    />
                    <span
                        className={`absolute scale-0 px-2 left-11 z-10  text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden'}`}
                    >Timer</span>
                    <TimerIcon />
                    {isExpanded && <span>Timer</span>}
                </button>
                <button
                    onClick={() => onMenuItemClick('stopwatch')}
                    className={`group relative flex items-center gap-2 px-3 py-2  ${activeMenu === 'stopwatch' ? 'text-yellow-400' : 'text-zinc-600 hover:text-zinc-400 '}  ${isExpanded ? 'w-full' : 'w-12'} transition-opacity duration-300`}>
                    <span
                        className={`absolute left-0 top-1/4 h-1/2 w-1 rounded-sm bg-yellow-400 ${activeMenu === 'stopwatch' && isExpanded ? '' : 'hidden'}`}
                    />
                    <span
                        className={`absolute scale-0 px-2 left-11 z-10  text-zinc-900 rounded-md bg-zinc-300 group-hover:scale-[100%] ${isExpanded && 'hidden'}`}>Stop&nbsp;Watch</span>
                    <StopWatchIcon />
                    {isExpanded && <span>Stop Watch</span>}
                </button>
            </div>

        </div>
    );
};

export default SideBar;
